import React from 'react';
import { Box, Typography, IconButton, Avatar, Chip, Fade } from '@mui/material';
import { ExitToApp as LogoutIcon } from '@mui/icons-material';
import { HOME_STYLES } from '../constants/homeConstants';
import PageVisitStatsComponent from './PageVisitStatsComponent';

const HomeHeader = ({ userLogged, onLogout }) => {
  return (
    <Fade in timeout={800}>
      <Box sx={{ mb: 2 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', md: 'center' },
            flexDirection: { xs: 'column', md: 'row' },
            gap: { xs: 3, md: 0 },
            mb: 2,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: { xs: 1, md: 2 },
              flexDirection: { xs: 'column', md: 'row' },
              width: { xs: '100%', md: 'auto' },
              textAlign: { xs: 'center', md: 'left' },
            }}
          >
            <Avatar
              sx={{
                ...HOME_STYLES.avatar,
                width: { xs: 56, md: 64 },
                height: { xs: 56, md: 64 },
                fontSize: { xs: '1.25rem', md: '1.5rem' },
              }}
            >
              {userLogged.names?.charAt(0)?.toUpperCase() || 'U'}
            </Avatar>
            <Box>
              <Typography
                variant="h3"
                color="primary"
                sx={{
                  fontWeight: 'bold',
                  fontSize: { xs: '1.75rem', md: '3rem' },
                  wordBreak: 'break-word',
                  lineHeight: { xs: 1.2, md: 1.167 },
                }}
              >
                ¡Bienvenido, {userLogged.names || 'Usuario'}!
              </Typography>
              <Typography
                variant="h6"
                color="text.secondary"
                sx={{
                  fontSize: { xs: '0.9rem', md: '1.25rem' },
                  mt: { xs: 0.5, md: 0 },
                }}
              >
                Sistema de Gestión Constructora Colonial
              </Typography>
              {userLogged.branch && userLogged.branch.length > 0 && (
                <Chip
                  label={`Sucursal: ${userLogged.branch[0]?.description || 'Principal'}`}
                  color="primary"
                  variant="outlined"
                  size="small"
                  sx={{ mt: 1 }}
                />
              )}
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              gap: 2,
              alignItems: 'center',
              width: { xs: '100%', md: 'auto' },
              mt: 0,
            }}
          >
            <PageVisitStatsComponent />
            <IconButton
              onClick={onLogout}
              sx={{
                ...HOME_STYLES.logoutButton,
                display: { xs: 'none', md: 'inline-flex' },
              }}
            >
              <LogoutIcon />
            </IconButton>
          </Box>
        </Box>
      </Box>
    </Fade>
  );
};

export default HomeHeader;
